<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>

  <!-- Page Wrapper -->
  <div class="page-wrapper shift-scheduling-page">
    <!-- Page Content -->
    <div class="content container-fluid">
      <!-- Page Header -->
      <shift-header :title="title" :path="path" :text="text" :text1="text1" :text2="text2" :text3="text3" />
      <!-- /Page Header -->

      <!-- Content Starts -->
      <!-- Search Filter -->
      <shift-scheduling-filter @attFilterClicked="searchClicked" :initialEmployeeId="employeeID" />
      <!-- Search Filter -->

      <div class="row">
        <div class="col-md-12">
          <div class="showentries mb-3 custom-select">
            <div class="d-flex align-items-center gap-2"><span>Show</span>
              <select v-model="perPage" @change="current = 1; getUserData()" style="outline: none">
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
              <span>entries</span>
            </div>
          </div>
          <div v-if="!loader">
            <div class="table-responsive">
              <a-table class="stripped table-hover" :columns="columns" :data-source="data" :pagination="false"
                v-if="columns.length > 1">
                <template #bodyCell="{ column, record }">
                  <template v-if="column.key === 'Name'">
                    <h2 class="table-avatar">
                      <a href="javascript:;" class="avatar" @click="openImagePreview(record)">
                        <img :src="getImage(record.profile_image_path)" alt="User Image"
                          v-if="record.profile_image_path" />
                        <img src="../../../assets/img/avatar/avatar-29.png" alt="User Image" v-else />
                      </a>
                      <action-dropdown @banked-time="bankedTimeClicked" :employee="record" variant="text" :showViewProfile="true" :reportAsEvent="true" @edit="editEmployeeClicked" @leaves="leavesClicked"
                        @attendance="attendanceClicked" @sick-leave="sickLeaveClicked" @add-face-template="addFaceTemplateClicked" @face-templates="faceTemplatesClicked" @toggle-monitoring="monitorClicked" @report="viewReport"
                        @reset-password="resetPasswordClicked" @assign-employee="assignEmployeeClicked"/>
                    </h2>
                  </template>
                  <div v-for="(data, index) in columns" :key="data.key">
                    <template v-if="column.key === data.key && index !== 0">
                      <div class="user-add-shedule-list">
                        <h2>
                          <a v-if="record?.user_schedule?.[index - 1]?.user_schedule_shifts?.length" class="a-block"
                            href="javascript:;" data-bs-toggle="modal" data-bs-target="#edit_schedule"
                            @click="editSchedule(record?.user_schedule?.[index - 1])">
                            <div class="d-flex align-items-center justify-content-between mb-1" v-if="record?.user_schedule?.[index - 1]?.updated_by">
                              <span class="badge bg-warning text-dark" style="font-size: 0.65rem;" :title="getScheduleUpdatedTooltip(record?.user_schedule?.[index - 1])">
                                <i class="fa-solid fa-pen-to-square me-1"></i>Edited
                              </span>
                            </div>
                            <div class="d-flex align-item-center">
                              <div v-for="(info, i) in record?.user_schedule?.[index - 1]?.user_schedule_shifts || []"
                                :key="info.id">

                                <span class="username-info m-b-10">&nbsp;Shift {{ i + 1 }} :
                                  {{ record?.user_schedule?.[index - 1]?.user_schedule_shifts?.[i]?.from_time ?
                                    record?.user_schedule?.[index - 1]?.user_schedule_shifts?.[i]?.from_time : '--' }} -
                                  {{ record?.user_schedule?.[index - 1]?.user_schedule_shifts?.[i]?.to_time ?
                                    record?.user_schedule?.[index - 1]?.user_schedule_shifts?.[i]?.to_time : '--'
                                  }}&nbsp;</span>
                              </div>
                            </div>
                            <div class="d-flex align-item-center">
                              <div v-for="(info, i) in record?.user_schedule?.[index - 1]?.user_schedule_break_conditions || []"
                                :key="info.id">
                                <span class="username-info m-b-10">&nbsp;Break {{ i + 1 }} :- Work Time
                                  :{{ convertMinutesToHours(record?.user_schedule?.[index -
                                    1]?.user_schedule_break_conditions?.[i]?.work_hours) ?
                                    convertMinutesToHours(record?.user_schedule?.[index -
                                      1]?.user_schedule_break_conditions?.[i]?.work_hours) : '--'
                                  }},&nbsp; Break Time:
                                  {{ convertMinutesToHours(record?.user_schedule?.[index -
                                    1]?.user_schedule_break_conditions?.[i]?.break_hours) ?
                                    convertMinutesToHours(record?.user_schedule?.[index -
                                      1]?.user_schedule_break_conditions?.[i]?.break_hours) : '--'
                                  }}&nbsp;</span>
                              </div>
                            </div>
                            <div v-if="record?.user_schedule?.[index - 1]?.updated_by" class="text-muted mt-1 text-truncate" style="font-size: 0.65rem; line-height: 1.1;" :title="getScheduleUpdatedTooltip(record?.user_schedule?.[index - 1])">
                              <span v-if="record?.user_schedule?.[index - 1]?.updated_by_user">
                                By {{ record?.user_schedule?.[index - 1]?.updated_by_user?.first_name }} {{ record?.user_schedule?.[index - 1]?.updated_by_user?.last_name }}
                              </span>
                              <span v-else>
                                By User #{{ record?.user_schedule?.[index - 1]?.updated_by }}
                              </span>
                              <span v-if="record?.user_schedule?.[index - 1]?.updated_at">
                                &bull; {{ formatScheduleUpdatedTime(record?.user_schedule?.[index - 1]?.updated_at) }}
                              </span>
                            </div>

                            <!-- <span  class="userrole-info">{{record?.user_schedule.length > 0 ?  record?.user_schedule[0].user_schedule_shifts[0].to_time:'--' }}</span> -->

                            <!-- <span  class="username-info m-b-10">{{ "record?.user_schedule.length" }}</span>
                        <span  class="userrole-info">{{"record?.user_schedule.length" }}</span> -->
                          </a>
                          <a v-else href="javascript:;" data-bs-toggle="modal" data-bs-target="#edit_schedule"
                            @click="editSchedule(record?.user_schedule?.[index - 1])">
                            <span v-if="record?.user_schedule?.[index - 1]?.updated_by" class="badge bg-warning text-dark me-1" style="font-size: 0.65rem;" :title="getScheduleUpdatedTooltip(record?.user_schedule?.[index - 1])">
                              <i class="fa-solid fa-pen-to-square me-1"></i>Edited
                            </span>
                            add schedule
                          </a>

                        </h2>
                      </div>
                    </template>
                  </div>
                  <!-- {{ record.user_schedule.length }} -->

                  <!-- <template v-else-if="column.key === 'Sat22'">
                  <div class="user-add-shedule-list">
                    <a href="javascript:;" data-bs-toggle="modal" data-bs-target="#add_schedule">
                      <span><i :class="record.ClassTwo"></i></span>
                    </a>
                  </div>
                </template>
                <template v-else-if="column.key === 'Sun23'">
                  <div class="user-add-shedule-list">
                    <a href="javascript:;" data-bs-toggle="modal" data-bs-target="#add_schedule">
                      <span><i :class="record.ClassTwo"></i></span>
                    </a>
                  </div>
                </template>
                <template v-else-if="column.key === 'Mon24'">
                  <div class="user-add-shedule-list">
                    <a href="javascript:;" data-bs-toggle="modal" data-bs-target="#add_schedule">
                      <span><i :class="record.ClassTwo"></i></span>
                    </a>
                  </div>
                </template>
                <template v-else-if="column.key === 'Tue25'">
                  <div class="user-add-shedule-list">
                    <a href="javascript:;" data-bs-toggle="modal" data-bs-target="#add_schedule">
                      <span><i :class="record.ClassTwo"></i></span>
                    </a>
                  </div>
                </template>
                <template v-else-if="column.key === 'Wed26'">
                  <div class="user-add-shedule-list">
                    <a href="javascript:;" data-bs-toggle="modal" data-bs-target="#add_schedule">
                      <span><i :class="record.ClassTwo"></i></span>
                    </a>
                  </div>
                </template>
                <template v-else-if="column.key === 'Thu27'">
                  <div class="user-add-shedule-list">
                    <h2>
                      <a href="javascript:;" data-bs-toggle="modal" data-bs-target="#edit_schedule"
                        :class="record.ClassOne">
                        <span class="username-info m-b-10">{{ record.Content }}</span>
                        <span class="userrole-info">{{ record.Role }}</span>
                      </a>
                    </h2>
                  </div>
                </template>
                <template v-else-if="column.key === 'Fri28'">
                  <div class="user-add-shedule-list">
                    <a href="javascript:;" data-bs-toggle="modal" data-bs-target="#add_schedule">
                      <span><i :class="record.ClassTwo"></i></span>
                    </a>
                  </div>
                </template>
                <template v-else-if="column.key === 'Sat29'">
                  <div class="user-add-shedule-list">
                    <a href="javascript:;" data-bs-toggle="modal" data-bs-target="#add_schedule">
                      <span><i :class="record.ClassTwo"></i></span>
                    </a>
                  </div>
                </template>-->
                </template>
              </a-table>
              <div v-else>
                <div class="card text-center">
                  <div class="card-body">
                    <img src="../../../assets/img/avatar/no-data.png" alt="no-data" srcset="" class="responsive-img">
                    <p>No records have been added for {{ month }}.</p>
                  </div>
                </div>
              </div>

            </div>
            <div class="d-flex justify-content-center">
              <a-pagination v-model:current="current" v-model:pageSize="perPage" :total="total" @change="getUserData"
                show-less-items class="mt-3 " :showSizeChanger="false">
                <template #itemRender="{ type, originalElement }">
                  <a v-if="type === 'prev'">Previous</a>
                  <a v-else-if="type === 'next'">Next</a>
                  <component :is="originalElement" v-else></component>
                </template>
              </a-pagination>
            </div>
          </div>
          <div class="d-flex justify-content-center text-center mt-5" v-else>
            <div class="spinner-border" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        </div>
      </div>

      <!-- /Content End -->
    </div>
    <!-- /Page Content -->

    <shift-list-modal></shift-list-modal>
    <edit-schedule-modal ref="editSchedul" @editedShift="getUserData" v-if="showEditModel"></edit-schedule-modal>
    <leaves-admin-modal ref="leaveAdmin" @allLeaves="getUserData"></leaves-admin-modal>
    <sick-leave-details-modal ref="sickLeaveDetails"></sick-leave-details-modal>
    <sick-leave-modal ref="sickLeave"></sick-leave-modal>
    <edit-employee-modal ref="editEmployee" @editedUser="getUserData"></edit-employee-modal>
    <add-face-template-modal ref="addface"></add-face-template-modal>
    <face-templates-modal ref="faceTemplates"></face-templates-modal>
    <employee-report-modal ref="employeeReportModal"></employee-report-modal>
    <reset-password-modal ref="resetPasswordModal"></reset-password-modal>
    <assign-employee-modal ref="assignEmployeeModal" @updated="getUserData"></assign-employee-modal>

    <!-- Image Preview Modal -->
    <div class="modal fade" id="image_preview_modal" tabindex="-1" aria-labelledby="imagePreviewLabel"
      aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="imagePreviewLabel">{{ selectedEmployeeName }}</h5>
            <button type="button" class="btn-close close-btn" data-bs-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body text-center">
            <img :src="selectedImageUrl" alt="Employee Image" class="img-fluid preview-image" />
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Page Wrapper -->
    <view-banked-time-details-modal ref="viewBankedTimeDetails"></view-banked-time-details-modal>
</template>

<script>
import { ref } from "vue";
import axios from 'axios';
import { Modal } from 'bootstrap';
import ActionDropdown from "@/components/action-dropdown.vue";
import FaceTemplatesModal from "@/components/modal/face-templates-modal.vue";
import AssignEmployeeModal from "@/components/modal/assign-employee-modal.vue";
import moment from "moment";
import { VUE_APP_API_BASE_URL } from "../../../config";
import { formatDDMMYYYY, formatUSDate, getImage, formatDateTimeStandardWithTime } from "@/utils/util-funcitons";
import { dateRangeStart, dateRangeEnd } from "@/utils/util-var";
const currentDate = ref(new Date());
const currentDateOne = ref(new Date());

import { monitorMixin } from "@/mixins/monitorMixin";
export default {
  mixins: [monitorMixin],
  components: {
    ActionDropdown,
    FaceTemplatesModal,
    AssignEmployeeModal
  },
  data() {
    return {
      select2: null,
      usersData: [],
      loader: false,
      title: "Employees Shift",
      path: "Dashboard",
      text: "Employees",
      text1: "Employees Shift",
      text2: "Shifts",
      text3: "Assign Shifts",
      employeeID: "",
      employeeName: "",
      perPage: 10,
      current: 1,
      total: 0,
      days: [],
      month: (new Date()).getMonth() + 1,
      year: (new Date).getFullYear(),
      isFocused: false,
      Finance: [
        "All Department",
        "Finance",
        "Finance and Management",
        "Hr & Finance",
        "ITech",
      ],
      startdate: currentDate,
      startdateone: currentDateOne,
      employeeRole: "",
      data: [],
      columns: [],
      accessToken: [],
      showEditModel: true,
      startDate: formatUSDate(dateRangeStart),
      endDate: formatUSDate(dateRangeEnd),
      selectedImageUrl: "",
      selectedEmployeeName: "",
      isManualSearch: false,
      requestId: 0
    };
  },
  mounted() {
    this.initializeFromQuery();
    this.days = this.datesInMonth(this.month, this.year);
    if (!this.employeeID) {
      this.getUserData();
    }
    this.setAction()
  },
  methods: {
    bankedTimeClicked(record) {
      if(this.$refs.viewBankedTimeDetails) {
        this.$refs.viewBankedTimeDetails.updateValues(record, {});
      }
    },

    getImage,
    datesInMonth(getMonth, getYear) {
      const year = getYear ? getYear : (new Date()).getFullYear();
      const month = getMonth ? new Date(`${getMonth} 1, 2022`).getMonth() + 1 : (new Date()).getMonth() + 1; // Month is 1-based (1-12)
      const daysInMonth = new Date(year, month, 0).getDate(); // Get the number of days in the current month

      // Helper function to pad month/day with a leading zero
      const padZero = (num) => (num < 10 ? `0${num}` : num);

      // Create an array of dates with the format "YYYY-MM-DD"
      const dates = [];
      for (let day = 1; day <= daysInMonth; day++) {
        // const formattedDate = `${year}-${padZero(month)}-${padZero(day)}`;
        const formattedDate = `${padZero(day)}/${padZero(month)}/${year}`;
        dates.push(formattedDate);
      }

      return dates;
    },

    convertMinutesToHours(minutes) {
      if (typeof minutes === 'number') {
        var num = minutes;
        var hours = (num / 60);
        var rhours = Math.floor(hours);
        var minute = (hours - rhours) * 60;
        var rminutes = Math.round(minute);
        console.log(rhours + ":" + rminutes);
        return rhours + ":" + rminutes;
      } else {
        return minutes
      }

    },

    generateColumns() {
      // const today = new Date();
      const columns = [
        {
          title: "Scheduled Shift",
          dataIndex: "Name",
          key: "Name",
          fixed: true,
          sorter: {
            compare: (a, b) => {
              a = a.Name.toLowerCase();
              b = b.Name.toLowerCase();
              return a > b ? -1 : b > a ? 1 : 0;
            },
          },
        }
      ];
      this.days.forEach(dateElement => {
        // Find matching schedule in user_schedule
        this.data.forEach(dateObject => {
          const matchedSchedule = (dateObject.user_schedule || []).find((schedule) => schedule.date === dateElement);
          const columnExists = columns.some((col) => col.title === dateElement);
          if (!columnExists) {
            if (matchedSchedule) {
              // If match is found, push column data
              columns.push({
                title: dateElement,
                dataIndex: matchedSchedule.date,
                key: matchedSchedule.date,
              });
            }
          }

        });
      });
      this.columns = columns;
      // return columns;
    },

    addFocusClass() {
      this.isFocused = true;
    },
    removeFocusClass() {
      this.isFocused = false;
    },

    async getUserData() {
      this.loader = true;
      const currentRequestId = ++this.requestId;
      
      // Convert numeric month (1-12) to month name string for API
      const apiMonth = moment().month(this.month - 1).format("MMMM");

      if (Number(this.perPage) >= this.total) {
        this.current = 1
      }
      await axios.get(`${VUE_APP_API_BASE_URL}/user-schedule/all?page=${this.current}`, {
        params: {
          per_page: this.perPage,
          month: apiMonth, // Use the converted month name
          year: this.year,
          employee_id: this.employeeID,
          employee_name: this.employeeName,
          role: this.employeeRole
        }
      })
        .then((response) => {
          if (currentRequestId !== this.requestId) return;
          if (response.data.status) {
            this.data = response.data.data.data;
            this.current = response.data.data.current_page;
            this.total = response.data.data.total;
            this.data.forEach(element => {
              element["name"] = element["first_name"] + " " + element["last_name"];
            });
            this.data.forEach(e => {
              e['user_schedule'] = Array.isArray(e['user_schedule']) ? e['user_schedule'] : [];
              e['user_schedule'].forEach(s => {
                s['user_schedule_shifts'] = Array.isArray(s['userScheduleShifts']) ? s['userScheduleShifts'] : (Array.isArray(s['user_schedule_shifts']) ? s['user_schedule_shifts'] : []);
                s['user_schedule_break_conditions'] = Array.isArray(s['userScheduleBreakConditions']) ? s['userScheduleBreakConditions'] : (Array.isArray(s['user_schedule_break_conditions']) ? s['user_schedule_break_conditions'] : []);
                let date = s['date']
                s['date'] = formatDDMMYYYY(date)
              })
            });
            this.generateColumns();
          } else {
            this.errorMessage = response.data.message ?? "";
          }
        })
        .finally(() => {
          if (currentRequestId === this.requestId) {
            this.loader = false;
          }
        });
    },
    searchClicked(data) {
      this.month = data.month;
      this.year = Number(data.year);
      this.employeeName = data.employee_name;
      this.employeeRole = data.company_role_id;
      this.employeeID = data.employee_id;
      this.days = this.datesInMonth(this.month, this.year)

      // Only clear route if it's NOT a synchronization event and we have query params to clear
      if (!data.isSync && Object.keys(this.$route.query).length > 0) {
        this.isManualSearch = true;
        this.$router.replace({ path: '/employee/shift-scheduling', query: {} }).finally(() => {
          setTimeout(() => {
            this.isManualSearch = false;
          }, 500);
        });
      }
      this.current = 1;
      this.getUserData();
    },
    getScheduleUpdatedTooltip(sched) {
      if (!sched || !sched.updated_by) return '';
      const user = sched.updated_by_user ? (sched.updated_by_user.first_name + ' ' + sched.updated_by_user.last_name) : ('User #' + sched.updated_by);
      const time = sched.updated_at ? formatDateTimeStandardWithTime(sched.updated_at) : '';
      return 'Updated by ' + user + (time ? ' at ' + time : '');
    },
    formatScheduleUpdatedTime(date) {
      if (!date) return '';
      return formatDateTimeStandardWithTime(date);
    },
    editSchedule(record) {
      if (this.showEditModel) {
        this.$refs.editSchedul.updateValues(record);
      }

    },
    sickLeaveClicked(record) {
      this.$refs.sickLeave.updateValues(record);
    },
    addFaceTemplateClicked(record) {
      this.$refs.addface.updateValues(record);
    },
    faceTemplatesClicked(employee) {
      this.$refs.faceTemplates.showTemplates(employee);
    },
    editEmployeeClicked(record) {
      this.$refs.editEmployee.updateValues(record);
    },
    leavesClicked(record) {
      const routeData = this.$router.resolve({ path: '/employee/leaves-employee', query: { id: record.id } });
      window.open(routeData.href, '_blank');
    },
    attendanceClicked(record) {
      const routeData = this.$router.resolve({ path: '/employee/attendance-employee', query: { id: record.id } });
      window.open(routeData.href, '_blank');
    },
    setAction() {
      this.accessToken = JSON.parse(localStorage.getItem("userInfo"));
      this.showEditModel = this.accessToken?.account_type === 'MEMBER' ? false : true;
    },

    openImagePreview(record) {
      if (record.profile_image_path) {
        this.selectedImageUrl = this.getImage(record.profile_image_path);
      } else {
        this.selectedImageUrl = require('../../../assets/img/avatar/avatar-29.png');
      }
      this.selectedEmployeeName = record.name;
      const modal = new Modal(document.getElementById('image_preview_modal'));
      modal.show();
    },
    viewReport(record) {
      this.$refs.employeeReportModal.updateValues(record.id, this.startDate, this.endDate);
      const modal = new Modal(document.getElementById('employee_report_modal'));
      modal.show();
    },
    resetPasswordClicked(record) {
      this.$refs.resetPasswordModal.updateValues(record);
    },
    assignEmployeeClicked(record) {
      this.$refs.assignEmployeeModal.updateValues(record);
    },

    initializeFromQuery() {
      if (this.$route.query.id) {
        const queryId = Array.isArray(this.$route.query.id) ? this.$route.query.id[0] : this.$route.query.id;
        const numericId = Number(queryId);

        if (!isNaN(numericId)) {
          this.employeeID = numericId;
        } else if (queryId) {
          this.employeeID = queryId;
        }
      } else {
        this.employeeID = "";
      }
      // Ensure month/year are synced with query if possible (optional enhancement)
    }
  },
  watch: {
    '$route.query': {
      handler() {
        if (!this.isManualSearch) {
          this.initializeFromQuery();
          this.getUserData();
        }
      },
      deep: true
    }
  }
};
</script>

<style scoped>
.a-block {
  display: block !important;
}


.responsive-img {
  width: 100%;
  max-width: 100px;
  height: auto;
}

.custom-select select {
  appearance: none;
  width: 50px;
  font-size: 14px;
  padding: 2px 5px;
  background-color: #fff;
  border: 1px solid #caced1;
  border-radius: 0.25rem;
  color: #000;
  cursor: pointer;
}

.avatar {
  cursor: pointer;
}

.avatar:hover {
  opacity: 0.8;
}

.preview-image {
  max-height: 70vh;
  object-fit: contain;
  border-radius: 8px;
}

.close-btn {
  background-color: #A6A8A9;
  height: 20px;
  width: 20px;
  border: 1px solid #A6A8A9;
  font-size: 20px;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}

.close-btn:hover {
  background-color: #099bf8;
  color: #ffffff;
  border-color: #099bf8;
}

.close-btn:hover span {
  color: #FFF;
}

.close-btn span {
  color: #373B3E;
}
</style>

<!-- Global style handles dropdown clipping universally -->
<style>
</style>
